import $ from 'jquery';
export default class CookieConsentActions {
    static revealStateClass = 'cookie-consent-ready';
    static hasBannerRevealBeenScheduled = false;
    static init() {
        this.hasBannerRevealBeenScheduled = false;
        this.setBannerHiddenState();
        $('.js__revoke-cookie-preferences').on('click', event => {
            event.preventDefault();
            this.showCookieBanner();
            if ('OneTrust' in window) {
                // @ts-ignore
                window.OneTrust.ToggleInfoDisplay();
            }
        });
        this.initCallbackToRemoveCookieBannerTabIndex();
        this.removeCookieBannerTabIndex();
        this.scheduleBannerReveal();
    }
    static onCookieConsentAdded(callback) {
        if ($('#onetrust-consent-sdk').length > 0) {
            callback();
            return;
        }
        const config = { childList: true, subtree: true };
        const observer = new MutationObserver(mutationsList => {
            for (const mutation of mutationsList) {
                if ($(mutation.addedNodes).filter('#onetrust-consent-sdk').length > 0) {
                    callback();
                    observer.disconnect();
                    return;
                }
            }
        });
        observer.observe($('body').get(0), config);
    }
    static initCallbackToRemoveCookieBannerTabIndex() {
        this.onCookieConsentAdded(() => {
            this.removeCookieBannerTabIndex();
            this.updateAriaHiddenState();
        });
    }
    static removeCookieBannerTabIndex() {
        $('#onetrust-banner-sdk').attr('tabindex', -1);
    }
    static setBannerHiddenState() {
        document.documentElement.classList.remove(this.revealStateClass);
    }
    static showCookieBanner() {
        document.documentElement.classList.add(this.revealStateClass);
        this.updateAriaHiddenState();
    }
    static scheduleBannerReveal() {
        if (this.hasBannerRevealBeenScheduled) {
            return;
        }
        this.hasBannerRevealBeenScheduled = true;
        let isRevealed = false;
        const reveal = () => {
            if (isRevealed) {
                return;
            }
            isRevealed = true;
            this.showCookieBanner();
        };
        const longFallbackTimerId = window.setTimeout(reveal, 6000);
        const shortTimerId = window.setTimeout(reveal, 4000);
        const interactionReveal = () => {
            window.clearTimeout(shortTimerId);
            window.clearTimeout(longFallbackTimerId);
            reveal();
        };
        window.addEventListener('pointerdown', interactionReveal, { passive: true, once: true });
        window.addEventListener('keydown', interactionReveal, { once: true });
        window.addEventListener('touchstart', interactionReveal, { passive: true, once: true });
        window.addEventListener('scroll', interactionReveal, { passive: true, once: true });
    }
    static updateAriaHiddenState() {
        const isVisible = document.documentElement.classList.contains(this.revealStateClass);
        $('#onetrust-banner-sdk').attr('aria-hidden', isVisible ? 'false' : 'true');
    }
}
